import React, { useState } from 'react';

import Spin from 'antd/es/spin';

import MainLayout from 'layouts/Main.layout';
import { Row } from 'components/layout';
import PageHeader from 'components/MainPageHeader';

import useBISource from 'hooks/useBISource';

const LoadStatsBI = () => {
  const { source, isLoading } = useBISource('loadings');
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  return (
    <MainLayout
      style={{
        overflow: 'hidden',
      }}
    >
      <PageHeader
        title="Outbound"
        icon="share-2"
      />
      {
        isLoading || !isIframeLoaded ? (
          <Row style={{ padding: '12px 24px' }}>
            <Spin
              size={32}
              style={{ width: '100%', padding: '36px' }}
            />
          </Row>
        ) : null
      }
      {
        source ? (
          <iframe
            title="Unloadings"
            src={source}
            frameBorder="0"
            border="0"
            onLoad={() => {
              setTimeout(() => {
                setIsIframeLoaded(true);
              }, 500);
            }}
            hidden={!isIframeLoaded}
            style={{
              marginLeft: '8px',
              width: '100%',
              height: 'calc(100% - 95px)',
              outline: 'none',
              border: 'none',
              background: 'transparent',
            }}
          />
        ) : null
      }
  </MainLayout>
  );
};

export default LoadStatsBI;
